"use client";

import { ToastItem } from "@/components/Toast/ToastItem";
import { ToastsContainer } from "@/components/Toast/style";
import { useToast } from "@/hooks/useToast";

export const ToastContainer = () => {
  const { toasts } = useToast();
  if (!toasts.length) {
    return null;
  }
  return (
    <ToastsContainer aria-live="polite">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </ToastsContainer>
  );
};
